export { default } from './InfoWithImageQuizStep';
